const CAR_CATEGORY = {
    CABRIOLET: 'CABRIOLET',
    LUXURY: 'LUXURY',
    PERFORMANCE: 'PERFORMANCE',
    SUV: 'SUV',
    ELECTRIC: 'ELECTRIC',
    HYBRID: 'HYBRID'
}

const CAR_UNIT = {
    DRIVE_POWER: 'kW',
    DRIVE_TORQUE: 'Nm',
    ACCELERATION: 's',
}

const KW_TP_METRIC_HP = 1.35962;

const CAR_STATUS = {
    INFLOW: 'INFLOW',
    AVAILABLE: 'AVAILABLE',
    OPERATING: 'OPERATING',
    CRASHED: 'CRASHED',
    UNDER_REPAIR: 'UNDER_REPAIR',
    SOLD: 'SOLD'
}

const ACQUISITION_TYPE = {
    RISK: 'RISK',
    RENT: 'RENT',
}

exports = module.exports = {
    CAR_CATEGORY,
    CAR_UNIT,
    KW_TP_METRIC_HP,
    CAR_STATUS,
    ACQUISITION_TYPE
}